import React, { useEffect, useState } from "react";
import IMG from "../../assets/img/spellinglogo.png";
import axios from "axios";

const animations = ["fade", "scale", "bounce", "float"];

const getRandomStyle = () => {
  const fontSizes = [
    "10px",
    "12px",
    "16px",
    "20px",
    "24px",
    "28px",
    "32px",
    "40px",
    "45px",
  ];
  const fontWeights = ["normal", "bold"];
  const colors = [
    "#ffdab9",
    "#b0e0e6",
    "#add8e6",
    "#f0e68c",
    "#e6e6fa",
    "#d8bfd8",
    "#fafad2",
  ];
  const animation = animations[Math.floor(Math.random() * animations.length)];

  return {
    fontSize: fontSizes[Math.floor(Math.random() * fontSizes.length)],
    fontWeight: fontWeights[Math.floor(Math.random() * fontWeights.length)],
    color: colors[Math.floor(Math.random() * colors.length)],
    margin: "15px",
    whiteSpace: "nowrap",
    display: "inline-block",
    animation: `${animation} ${Math.random() * (20 - 15) + 15}s infinite`,
  };
};

const FullScreenWords = () => {
  const [wordList, setWordList] = useState([]);

  const fetchWords = async () => {
    try {
      const response = await axios.get(
        "https://s3napi.s3nsoftware.com/api/WordOfTheDay/DashboardWords"
      );
      const fetchedWords = response.data.flatMap((item) =>
        item.Word.split("#<@>#")
      );
      generateWords(fetchedWords);
    } catch (error) {
      console.error("Error fetching words:", error);
    }
  };

  const generateWords = (sourceWords) => {
    const containerWidth = window.innerWidth;
    const containerHeight = window.innerHeight - 200;
    const wordsPerRow = Math.floor(containerWidth / 100);
    const rows = Math.floor(containerHeight / 40);
    const totalWords = wordsPerRow * rows;

    const shuffledWords = [...sourceWords].sort(() => Math.random() - 0.5);
    const newWords = shuffledWords.slice(0, totalWords);

    setWordList(newWords);
  };

  useEffect(() => {
    fetchWords();
    window.addEventListener("resize", fetchWords);

    const interval = setInterval(
      fetchWords,
      Math.random() * (15000 - 10000) + 10000
    );

    return () => {
      window.removeEventListener("resize", fetchWords);
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      <div
        style={{
          margin: 0,
          padding: 0,
          height: "100vh",
          backgroundColor: "#b768a2",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          position: "relative",
        }}
      >
        <style>
          {`@keyframes fade {
              0%, 100% { opacity: 0; }
              50% { opacity: 1; }
            }
            @keyframes scale {
              0%, 100% { transform: scale(1); }
              50% { transform: scale(1.3); }
            }
            @keyframes bounce {
              0%, 100% { transform: translateY(0); }
              50% { transform: translateY(-10px); }
            }
            @keyframes float {
              0%, 100% { transform: translateX(0); }
              50% { transform: translateX(10px); }
            }`}
        </style>

        <div
          style={{
            width: "100%",
            height: "55vh",
            overflow: "hidden",
            display: "flex",
            flexWrap: "wrap",
            alignContent: "flex-start",
            justifyContent: "center",
            fontSize: "20px",
            lineHeight: "1",
            padding: "10px",
            color: "#d3d3d3",
            wordSpacing: "0px",
            letterSpacing: "0px",
          }}
        >
          {wordList.map((word, index) => (
            <span key={index} style={getRandomStyle()}>
              {word}
            </span>
          ))}
        </div>
      </div>
    </>
  );
};

export default FullScreenWords;
